export class CreateWorkflowActionRequest {
  WorkflowID: number = -1;
  Title: string = '';
  Description: string = '';
  DefaultOwnerUserID?: number | null;
  DefaultOwnerTypeID?: number | null;
  DefaultDueInDays?: number | null;
  IsMandatory: boolean = false;
  ActionVariationID: number = 1;
  AuditID?: number | null;

  constructor(values: Partial<CreateWorkflowActionRequest> = {}) {
    Object.assign(this, values);
  }
}
